goog.provide('el8.practicedata.rxSigs');

goog.require('el8.model.base');
goog.require('el8.service.urls');

/* Practice-local Rx sig favorites */
el8.practicedata.rxSigs = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('directions', true); // the "sig" (called "directions" to match the medOrder model)
    // this is a single over all sigs in the set (used in settings), but we only really care
    // about the relative ordering of sigs given a single med
    _class.addIntProperty('sequence'); 

    _class.addStringProperty('sourceId', true);
    _class.addStringProperty('sourceType', true); // e.g. medispanDDID
    _class.addStringProperty('name', true); // display name


    var that =  new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('rxSigs'); },
        urlFn: function(id) { return el8.service.urls.get('rxSigs', [id]); },
        sortFn: function(a, b) { return a.getSequence() - b.getSequence(); },
        saveFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('rxSigs', [item.getId()]),
                data: JSON.stringify(item.asMap()),
                success: function(data) {
                    item.populate(data);
                    successCb(data);
                },
                error: errorCb,
                error_msg: function(responseCode, defaultMsg) {
                    if (responseCode === 409) {
                        return 'This sig already exists in your practice. Please edit the existing sig instead of creating a new one.';
                    }
                    return defaultMsg;
                }
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('rxSigs', [item.getId()]),
                success: successCb,
                error: errorCb
            });
        }
    });
    that.reOrder = function(idList, successCb, errorCb, opts) {
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('rxSigsReorder'),
            data: JSON.stringify({'sequence': idList}),
            success: function(data) {
                that.create(data);
                if (successCb) { successCb(data); }
            },
            error: errorCb
        });
    };
    that.getAll = function() {
        return that.sorted().map(function(sig) { return sig.getDirections(); });
    };

    that.getAllBySourceId = function(sourceId) {
        var sigs =  that.sorted().filter(function(sig) { return sig.getSourceId() === sourceId; });
        return sigs.map(function(s) { return s.getDirections(); });
    };

    return that;
})();